export const TRANSLATIONS_FR_ONBOARDING = {
  "homePublic.hero.eyebrow": "Vue en direct",
  "homePublic.hero.title": "Votre espace prêt pour l'entreprise avant toute connexion",
  "homePublic.hero.subtitle":
    "Explorez un environnement simulé avec des métriques anonymisées pour voir comment Innovadoc IA aligne les équipes avant la mise en production.",
  "homePublic.hero.ctaPrimary": "Créer mon compte",
  "homePublic.hero.ctaSecondary": "Accéder à mon workspace",
  "homePublic.hero.metrics.documents": "Documents indexés",
  "homePublic.hero.metrics.latency": "Temps de réponse médian",
  "homePublic.hero.metrics.compliance": "Couverture de connaissance",
  "homePublic.mock.eyebrow": "Télémetrie simulée",
  "homePublic.mock.title": "Signaux générés avec des données sûres",
  "homePublic.mock.subtitle":
    "Ces chiffres se mettent à jour automatiquement pour illustrer le comportement de la plateforme sous trafic réel.",
  "homePublic.mock.cards.documents.label": "Documents cette semaine",
  "homePublic.mock.cards.documents.detail": "Chargements uniques synchronisés sur les 7 derniers jours",
  "homePublic.mock.cards.repositories.label": "Sources connectées",
  "homePublic.mock.cards.repositories.detail": "Drive, SharePoint, S3, Gmail et plus",
  "homePublic.mock.cards.users.label": "Sièges actifs",
  "homePublic.mock.cards.users.detail": "Membres utilisant le chat et les automatisations",
  "homePublic.mock.cards.alerts.label": "Alertes d'attention",
  "homePublic.mock.cards.alerts.detail": "Éléments de remédiation en attente pour les admins",
  "homePublic.features.eyebrow": "Ce que vous obtenez",
  "homePublic.features.title": "Prêt pour l'entreprise dès le premier jour",
  "homePublic.features.subtitle": "Tout ce dont vous avez besoin pour tester l'expérience sans toucher aux données de production.",
  "homePublic.features.ingestion.title": "Ingestion sans friction",
  "homePublic.features.ingestion.desc": "Déposez des dossiers, transférez des emails ou connectez des dépôts en quelques minutes.",
  "homePublic.features.security.title": "Sécurité avant tout",
  "homePublic.features.security.desc": "Contrôles alignés SOC 2, permissions granulaires et isolation par workspace.",
  "homePublic.features.operations.title": "Orienté opérations",
  "homePublic.features.operations.desc": "Tableaux de bord en direct, alertes de santé et files de tâches pour l'humain dans la boucle.",
  "homePublic.plan.eyebrow": "Aperçu du plan",
  "homePublic.plan.title": "Offre Starter avec vraies garanties",
  "homePublic.plan.subtitle": "Pensée pour les leaders innovation qui valident des expériences RAG avec leurs parties prenantes internes.",
  "homePublic.plan.points.speed.title": "Pilotes plus rapides",
  "homePublic.plan.points.speed.desc": "Provisionnez des stores vectoriels dédiés et des flux de chat prêts à l'emploi.",
  "homePublic.plan.points.context.title": "Contexte fiable",
  "homePublic.plan.points.context.desc": "Détecte automatiquement les PII, classe les dépôts et conserve la traçabilité de chaque chunk.",
  "homePublic.plan.points.support.title": "Déploiement guidé",
  "homePublic.plan.points.support.desc": "Équipe Customer Success et office hours asynchrones pour garder le rythme.",
  "homePublic.plan.card.title": "Ce qui est inclus",
  "homePublic.plan.card.subtitle": "10 utilisateurs · 2 workspaces · 50K crédits de prompts · télémétrie premium.",
  "homePublic.plan.card.ctaPrimary": "Lancer un pilote gratuit",
  "homePublic.plan.card.ctaSecondary": "Voir les options enterprise",
  "homePublic.testimonial.quote": "L'environnement simulé a permis à notre équipe conformité d'approuver le déploiement en une semaine.",
  "homePublic.testimonial.author": "Lucía Hernández",
  "homePublic.testimonial.role": "Directrice Transformation IA, Vectoris",
  "homePublic.cta.title": "Prêt à voir vos documents s'illuminer ?",
  "homePublic.cta.subtitle": "Déployez Innovadoc IA avec des données fictives aujourd'hui et connectez vos dépôts dès que le juridique donne son feu vert.",
  "homePublic.cta.primary": "Lancer le workspace",
  "homePublic.cta.secondary": "Parler à un expert",
  "wizard.welcome_title": "Bienvenue dans l'assistant !",
  "wizard.welcome_image_alt": "Illustration de bienvenue",
  "wizard.welcome_description":
    "Configurez votre profil et vos préférences pour commencer à utiliser le système.",
  "wizard.profile_title": "Informations du profil",
  "wizard.profile_description": "Parlez-nous de vous et de votre organisation.",
  "wizard.preferences_title": "Préférences",
  "wizard.preferences_description":
    "Personnalisez votre expérience en sélectionnant le thème, la langue et d'autres options.",
  "wizard.complete_title": "C'est fait !",
  "wizard.complete_description": "Votre profil a été configuré correctement.",
  "wizard.feature_chat_title": "Chat intelligent",
  "wizard.feature_chat_desc":
    "Posez des questions et obtenez des réponses précises basées sur vos documents.",
  "wizard.feature_docs_title": "Gestion des documents",
  "wizard.feature_docs_desc":
    "Téléversez, organisez et consultez facilement vos documents.",
  "wizard.feature_insights_title": "Analyses et insights",
  "wizard.feature_insights_desc":
    "Obtenez des analyses et des statistiques pertinentes sur vos données.",
  "wizard.first_name": "Prénoms",
  "wizard.first_name_required": "Les prénoms sont obligatoires.",
  "wizard.lastname": "Nom de famille",
  "wizard.lastname_required": "Les noms de famille sont obligatoires.",
  "wizard.name_required": "Le nom est obligatoire.",
  "wizard.country": "Pays",
  "wizard.country_required": "Le pays est obligatoire.",
  "wizard.job_title": "Poste",
  "wizard.job_required": "Le poste est obligatoire.",
  "wizard.company": "Entreprise",
  "wizard.company_required": "L'entreprise est obligatoire.",
  "wizard.timezone": "Fuseau horaire",
  "wizard.timezone_select": "Sélectionnez votre fuseau horaire",
  "wizard.timezone_required": "Le fuseau horaire est obligatoire.",
  "wizard.timezone_search": "Rechercher une ville ou zone...",
  "wizard.timezone_no_results": "Aucun résultat",
  "wizard.org_type": "Type d'organisation",
  "wizard.org_enterprise": "Entreprise",
  "wizard.org_education": "Éducation",
  "wizard.org_government": "Gouvernement",
  "wizard.org_nonprofit": "ONG",
  "wizard.org_other": "Autre",
  "wizard.org_size": "Taille de l'organisation",
  "wizard.size_small": "Petite (1-50)",
  "wizard.size_medium": "Moyenne (51-250)",
  "wizard.size_large": "Grande (251-1000)",
  "wizard.size_enterprise": "Grande entreprise (1000+)",
  "wizard.theme_preference": "Préférence de thème",
  "wizard.language_preference": "Préférence de langue",
  "wizard.yes": "Oui",
  "wizard.no": "Non",
  "wizard.other_preferences": "Autres préférences",
  "wizard.enable_notifications": "Activer les notifications",
  "wizard.allow_data_collection": "Autoriser la collecte de données anonymes",
  "wizard.data_collection_info":
    "Vos données aident à améliorer le système. Aucune information personnelle n'est collectée.",
  "wizard.summary_title": "Résumé de la configuration",
  "wizard.previous": "Précédent",
  "wizard.next": "Suivant",
  "wizard.complete": "Terminer",
  "wizard.save_error":
    "Erreur lors de l'enregistrement de la configuration. Veuillez réessayer.",
  "wizard.copy_support_reference": "Copier le code",
  "wizard.support_reference_copied": "Copié",
  "wizard.second_name": "Nom de famille",
  "wizard.second_name_required": "Le nom de famille est obligatoire.",
  filtered_results: "résultats filtrés",
  "invite.validating": "Validation de l'invitation...",
  "invite.invalid_or_expired": "Invitation invalide ou expirée",
  "invite.invalid_or_expired_desc": "Le lien d'invitation n'est plus valide. Demandez une nouvelle invitation à votre administrateur.",
  "invite.missing_params": "Invitation incomplète",
  "invite.missing_params_desc": "Le lien d'invitation ne contient pas les informations nécessaires pour continuer.",
  "invite.not_found": "Invitation introuvable",
  "invite.not_found_desc": "Aucune invitation active n'a été trouvée pour cet e-mail.",
  "invite.server_error": "Nous n'avons pas pu valider l'invitation",
  "invite.server_error_desc": "Une erreur est survenue lors de la validation de l'invitation. Réessayez plus tard.",
  "invite.bad_request": "Les informations envoyées ne sont pas valides.",
  "invite.back_to_login": "Retour à la connexion",
  "invite.email": "E-mail invité",
  "invite.company": "Entreprise",
  "invite.role": "Rôle",
  "invite.company_from_invite": "L'entreprise est définie par l'invitation.",
  "invite.password_step": "Créez votre mot de passe",
  "invite.password_step_desc": "Définissez un mot de passe sécurisé pour finaliser votre accès.",
  "invite.password": "Mot de passe",
  "invite.password_placeholder": "Saisissez votre mot de passe",
  "invite.password_required": "Le mot de passe est obligatoire.",
  "invite.password_min_length": "Le mot de passe doit contenir au moins 8 caractères.",
  "invite.password_hint": "Utilisez au moins 8 caractères.",
  "invite.confirm_password": "Confirmer le mot de passe",
  "invite.confirm_password_placeholder": "Répétez votre mot de passe",
  "invite.passwords_not_match": "Les mots de passe ne correspondent pas.",
};
